module.exports = __webpack_public_path__ + "static/media/NO.522912bd.png";